import React, { useEffect, useState } from 'react';
import B2BElementsExplorer from './B2BElementsExplorer';
import { arraysAreEqual } from './helpers';

const B2BElementsExplorerInMemory = ({ elementsData, currentPage = 1, numRows = 5, ...rest }) => {
    const [displayedElements, setDisplayedElements] = useState({ content: elementsData.content.slice((currentPage - 1) * numRows, (currentPage - 1) * numRows + numRows) });
    const [totalPages, setTotalPages] = useState(Math.ceil(elementsData.content.length / numRows));
    const [actualPage, setActualPage] = useState(currentPage);

    useEffect(() => {
        const toDisplayElements = elementsData.content.slice((currentPage - 1) * numRows, (currentPage - 1) * numRows + numRows);
        if (!arraysAreEqual(displayedElements.content, toDisplayElements)) { // Only update if the content has changed
            setDisplayedElements({
                ...displayedElements,
                content: elementsData.content.slice((currentPage - 1) * numRows, (currentPage - 1) * numRows + numRows)
            });
        }
        if (currentPage !== actualPage) {
            setActualPage(currentPage);
        }
        const newTotalPages = Math.ceil(elementsData.content.length / numRows);
        if (newTotalPages !== totalPages) {
            setTotalPages(newTotalPages);
        }
    }, [elementsData, currentPage, numRows]);

    const handlePageChange = (event, page) => {
        setActualPage(page);
        setDisplayedElements({
            ...displayedElements,
            content: elementsData.content.slice((page - 1) * numRows, (page - 1) * numRows + numRows)
        });
    }

    return (
        displayedElements && (
            <B2BElementsExplorer
                elementsData={displayedElements}
                pagesCount={totalPages}
                currentPage={actualPage}
                handlePageChange={handlePageChange}
                {...rest}
            />
        )
    );
};

export default B2BElementsExplorerInMemory;